// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"Main_mainContent__P1EWy","mainGrid":"Main_mainGrid__gzICP","content":"Main_content__tmr5D"};